import { createInitialContext, enter, noop, Runtime, state, } from "@druyan/druyan";
import isFunction from "lodash.isfunction";
import React, { useContext, useEffect, useMemo, useState, } from "react";
export function createDruyanContext(_states, actions, options = {
    maxHistory: 5,
}) {
    const { restartOnInitialStateChange, maxHistory, fallback } = options;
    const parentContext = options.parent
        ? options.parent.Context
        : React.createContext({});
    const defaultContext = createInitialContext([state("Placeholder", () => noop())()], { maxHistory });
    const StateContext = React.createContext({
        context: defaultContext,
        currentState: defaultContext.currentState,
        actions,
    });
    function Create({ initialState: initialStateProp, children, }) {
        const [initialState, resetState] = useState(initialStateProp);
        useEffect(() => {
            if (restartOnInitialStateChange) {
                resetState(initialStateProp);
            }
        }, [initialStateProp]);
        const possibleParentContext = useContext(parentContext);
        const parentRuntime = possibleParentContext
            ? possibleParentContext.runtime
            : undefined;
        const runtime = useMemo(() => Runtime.create(createInitialContext([initialState], { maxHistory }), Object.keys(actions), fallback, parentRuntime), [initialState]);
        const boundActions = useMemo(() => runtime.bindActions(actions), [runtime]);
        const [value, setValue] = useState({
            context: runtime.context,
            currentState: runtime.context.currentState,
            actions: boundActions,
            runtime,
        });
        useEffect(() => {
            const unsub = runtime.onContextChange(context => {
                setValue({
                    context,
                    currentState: context.currentState,
                    actions: boundActions,
                    runtime,
                });
            });
            runtime.run(enter());
            return unsub;
        }, []);
        return (React.createElement(StateContext.Provider, { value: value }, isFunction(children) ? (React.createElement(StateContext.Consumer, null, currentValue => children({
            actions: currentValue.actions,
            context: currentValue.context,
            currentState: currentValue.context.currentState,
        }))) : (children)));
    }
    return {
        Context: StateContext,
        Create,
    };
}
//# sourceMappingURL=createDruyanContext.js.map